import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "../../../../components/Layout/Header/Header";
import Footer from "../../../../components/Layout/Footer/Footer";
import ScrollToTop from "../../../../components/Common/ScrollTop";
import OffWrap from "../../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../../components/Common/Breadcumb";
import SearchModal from "../../../../components/Layout/Header/SearchModal";
import footerLogo from "../../../../assets/img/logo/jntua-logo.png";
import { fetchData } from "../../../../utils/fetchData";
import Accreditation from "../../../../components/Common/Accreditation";
import { useFontSize } from "../../../../FontSizeContext";
import { getMenu, getAPIPath } from "../../../../utils/getDomainData";

const SMS_GuestLectures = () => {
  const [data, setData] = useState([]);
  let location = useLocation();
  const currentDomain = location.pathname.split("/")[1];
  const { fontSize } = useFontSize();

  useEffect(() => {
    fetchData(getAPIPath(currentDomain)?.guestLectures, setData);
  }, [currentDomain]);

  return (
    <React.Fragment>
      <Helmet>
        <title>Guest Lectures | SMS | JNTU Anantapur</title>
        <meta
          name="description"
          content="Guest lectures and visitors at School of Management Studies, JNTUA"
        />
        <meta
          name="keywords"
          content="Guest Lectures, SMS, School of Management Studies, JNTUA, Visitors, Academic"
        ></meta>
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="home"
        TopBar="enable"
        TopBarClass="topbar-area dark-primary-bg hidden-lg"
      />
      <style>
        {`
                    body,
                    .rs-latest-events.style1 .event-wrap .events-short .date-part .date,
                    .widget ul li a {
                        font-size: ${fontSize}px;
                    }
                    .rs-inner-blog .blog-item .blog-content .blog-title,
                    .widget h1,.content-wrapper h2, .heading, .college-title{
                        font-size: calc(${fontSize}px + 10px);
                    }
                    .breadcrumb-bg .breadcrumbs-text ul li{
                      font-size: calc(${fontSize}px + 2px);
                    }
                    
                    .full-width-header .rs-header .topbar-area .topbar-right li.login-register a,
                    .readon.orange-btn, .rs-latest-events.bg-wrap .notification-filter button,
                    .rs-latest-events.style1 .event-wrap:not(.ls-area) .events-short .slNo, 
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > a,
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > ul li > a,
                    table th, table td {                       
                        font-size: calc(${fontSize}px - 2px);
                    }

                    .rs-footer .footer-top-social .social_msg{
                        font-size: calc(${fontSize}px + 18px);
                    }
                    .rs-footer .footer-center h3{
                        font-size: calc(${fontSize}px + 12px);
                    }
                    .rs-footer.home9-style .footer-top .widget-title,
                    .rs-team.style1 .about-btn--primary,
                    .rs-team.style1 .about-btn--secondary,
                    .course-overview .inner-box h5{
                        font-size: calc(${fontSize}px + 4px);
                    }
                    .rs-footer .footer-center h4,
                    .rightBar h4{
                        font-size: calc(${fontSize}px + 6px);
                    }
                    
                    .year-section {
                        margin-bottom: 40px;
                    }
                    
                    .year-header {
                        background: linear-gradient(135deg, #ff6600, #ff8533);
                        color: white;
                        padding: 15px 25px;
                        border-radius: 8px;
                        font-size: calc(${fontSize}px + 6px);
                        font-weight: bold;
                        margin-bottom: 20px;
                        box-shadow: 0 3px 6px rgba(255,102,0,0.3);
                    }
                    
                    .guest-table {
                        width: 100%;
                        border-collapse: collapse;
                        background: white;
                        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                        border-radius: 8px;
                        overflow: hidden;
                    }
                    
                    .guest-table thead {
                        background: #f8f9fa;
                    }
                    
                    .guest-table th {
                        padding: 15px;
                        text-align: left;
                        font-weight: bold;
                        color: #333;
                        border-bottom: 2px solid #ff6600;
                    }
                    
                    .guest-table td {
                        padding: 15px;
                        border-bottom: 1px solid #e9ecef;
                        color: #555;
                    }
                    
                    .guest-table tbody tr:hover {
                        background-color: #fff8f3;
                    }
                    
                    .guest-table tbody tr:last-child td {
                        border-bottom: none;
                    }
                    
                    .serial-number {
                        font-weight: 600;
                        color: #ff6600;
                        min-width: 50px;
                    }
                    
                `}
      </style>
      <div className="pageTopOffset">
        {/* breadcrumb-area-start */}
        <SiteBreadcrumb
          pageTitle="Guest Lectures"
          pageName="Guest Lectures"
          breadcrumbsClass="breadcrumb-bg"
        />
        {/* breadcrumb-area-start */}
        {getMenu(currentDomain)}
        <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
          <div className="container">
            <div className="row">
              <div className="col pl-20 md-pl-14">
                <div className="row">
                  <div className="rs-inner-blog col-lg-12">
                    <h3 className="college-title">
                      {data?.data?.attributes?.heading || "List of Guests Visited the Department"}
                    </h3>
                    
                    {data?.data?.attributes?.sections?.length > 0 ? (
                      // Sort sections by year in descending order
                      [...data.data.attributes.sections]
                        .sort((a, b) => parseInt(b.year) - parseInt(a.year))
                        .map((section, sectionIndex) => (
                        <div key={section.id || sectionIndex} className="year-section">
                          <div className="year-header">
                            Year: {section.year}
                          </div>
                          
                          {section.guests?.length > 0 ? (
                            <div className="overflow-x">
                              <table className="guest-table table table-striped">
                                <thead>
                                  <tr>
                                    <th scope="col" style={{ width: "80px" }}>S.No</th>
                                    <th scope="col">Guest Details</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {section.guests.map((guest, index) => (
                                    <tr key={guest.id || index}>
                                      <td className="serial-number">
                                        {(index + 1).toString().padStart(2, "0")}.
                                      </td>
                                      <td>{guest.fullEntry}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          ) : (
                            <div style={{ 
                              padding: "30px", 
                              textAlign: "center", 
                              backgroundColor: "#f8f9fa",
                              borderRadius: "8px",
                              color: "#999"
                            }}>
                              No guest records available for {section.year}
                            </div>
                          )}
                        </div>
                      ))
                    ) : (
                      <div className="text-center" style={{ padding: "60px 20px" }}>
                        <div style={{ color: "#666", fontSize: "16px" }}>
                          <i className="fas fa-users" style={{ fontSize: "48px", marginBottom: "20px", color: "#ddd" }}></i>
                          <br />
                          No guest lecture information available at the moment.
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Accreditation />

      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />

      {/* scrolltop-start */}
      <ScrollToTop scrollClassName="scrollup orange-color" />
      {/* scrolltop-end */}

      <SearchModal />
    </React.Fragment>
  );
};

export default SMS_GuestLectures;